import React from 'react';

export const PrivacyPolicy = () => (
    <>
        <h3>Oberhof Drinks <br />Privacy Policy</h3>

        <div className="privacy">

            <p>This Privacy Policy governs the manner in which Oberhof Drinks collects, uses, maintains and discloses information collected from users (each, a “User”) of the https://oberhofdrinks.com website (“Site”).</p>
            Personal identification information
            
<p>We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, respond to a survey, and in connection with other activities, services, features or resources we make available on our Site. Users may visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.
Non-personal identification information</p>

            <p>We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.
Web browser cookies</p>

            <p>Our Site may use “cookies” to enhance User experience. User’s web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.
How we use collected information</p>

            <p>Oberhof Drinks® may collect and use Users personal information for the following purposes:</p>

            <p>To run and operate our Site</p>
            <p>We may need your information display content on the Site correctly.</p>

            <p>How we protect your information</p>

            <p>We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.
Sharing your personal information</p>

            <p>We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above.</p>

            <p>We may share or sell information with third parties for marketing or other purposes.
Sharing your personal information</p>

            <p>This Privacy Policy governs the manner in which Oberhof Drinks® collects, uses, maintains and discloses information collected from users (each, a “User”) of the https://oberhofdrinks.com website (“Site”).
Personal identification information</p>

            <p>We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, respond to a survey, and in connection with other activities, services, features or resources we make available on our Site. Users may visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.
Non-personal identification information</p>

            <p>We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.
Web browser cookies</p>

            <p>Our Site may use “cookies” to enhance User experience. User’s web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.
How we use collected information</p>

            <p>Oberhof Drinks® may collect and use Users personal information for the following purposes:</p>

            <p>To run and operate our Site</p>
            <p>We may need your information display content on the Site correctly.</p>

            <p>How we protect your information</p>

            <p>We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.
Sharing your personal information</p>

            <p>We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above.</p>

            <p>We may share or sell information with third parties for marketing or other purposes.
Changes to this privacy policy</p>

            <p>Oberhof Drinks® has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.
Your acceptance of these terms</p>

            <p>By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes.
Contacting us</p>

            <p>If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us.</p>

            This document was last updated on August 25, 2019
            
<p>Company Detail:</p>

            <p>Barracuda Ic & Dis Tic Ltd Sti<br /><br />
                Korkun Mh. Sabahattin Cakmakoglu Cd. No 7,<br />
                27910, Oguzeli, Gaziantep, Turkey <br /><br />
                Tel: +90 342 220 1720 <br /><br />
                Tax Id & No: Suburcu - 142 063 2744 <br />
                Mersis No: 0142063274400014</p>

        </div>
        <style jsx>{`
      .privacy {
        color: #777;
        max-width: 800px;
        margin: 0 auto 30px;
        padding: 20px;
      }
    `}</style>
    </>
)